import React, { Component } from 'react';
import {
  Modal,
} from 'react-bootstrap';
import { defer, each } from 'lodash';

function getStyle(className) {
  let cssText = null;
  const styles = document.styleSheets || [];
  each(styles, (style, i) => {
    const classes = style.rules || style.cssRules;
    each(classes, (c) => {
      if (c.selectorText === className) {
        cssText += c.cssText || c.style.cssText;
      }
    });
  });
  return cssText;
}

export class DetechChromeExtenstion extends Component {
  constructor() {
    super();
    this.state = {
      installed: false,
    };
  }
  componentDidMount() {
    defer(() => { this.check(); }); // after extension inject
  }

  check() {
    if (typeof document !== 'undefined') {
      let installed = false;
      const style = getStyle('ag-grid-angular, ag-grid-ng2');
      if (style !== null) {
        installed = true;
      }
      /*
      const p = document.createElement('div');
      p.setAttribute('class', 'ag-full-width-container');
      document.body.appendChild(p);
      const style1 = window.getComputedStyle(p);

      const l = document.createElement('div');
      l.setAttribute('class', 'ag-layout-normal');
      document.body.appendChild(l);

      const e = document.createElement('div');
      e.setAttribute('class', 'ag-header');
      l.appendChild(e);
      const style2 = window.getComputedStyle(e);
      if (style1.position === 'relative' && style2.position === 'absolute') {
        installed = true;
      }
      this.setState({ installed }, () => {
        l.remove();
        p.remove();
      });
      */
      this.setState({ installed });
    }
  }

  render() {
    const { installed } = this.state;
    if (!installed) {
      return null;
    }
    return (
      <Modal key="modal" show backdrop="static" keyboard={false}>
        <Modal.Body>
          <div className="alert alert-danger" style={{ margin: 0 }}>
            <p>We detected that you&rsquo;re using extension(s) that are incompatible with TruVoice Automation.</p>
            <p>Affected extension(s):</p>
            <ul>
              <li>
                <strong>Engagio</strong> (extension id: <code>hnfijcggbbnhciandggikibemjjjpoaf</code>)
              </li>
            </ul>
            <p>Please disable these extensions and reload this page.</p>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

DetechChromeExtenstion.propTypes = {
};
DetechChromeExtenstion.defaultProps = {
};
export default DetechChromeExtenstion;
